module.exports = __webpack_public_path__ + "static/media/linkedinBlack.00e1905e.svg";